<template>
  <section class="hero">
    <div class="container">
      <table
        width="100%"
        border="0"
        cellspacing="0"
        cellpadding="0"
        align="center"
        style="margin: 0 !important; padding: 0 !important"
        class="logo-n-menu"
      >
        <tbody>
          <tr>
            <td class="logo" width="50%">
              <renters-logo></renters-logo>
            </td>
            <td class="nav" width="50%">
              <home-burger-menu></home-burger-menu>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        class="left aos-init aos-animate"
        data-aos="fade-right"
        data-aos-duration="2000"
      >
        <div class="hidemobile"><br /><br /></div>
        <br /><br />
        <div class="hero-title">
          Affordable <span>Renters Insurance</span>
          <div class="subhero-title">for College Students</div>
        </div>

        <router-link :to="{ name: 'quote' }">
          <button>Start a Quote</button>
        </router-link>

        <p>
          Apartment, House, Condo, Townhouse, or Dorm Room.
          <span style="display: block">
            The unexpected can happen. NSSI has your back when it does.
          </span>
        </p>
        <br />
        <p><strong>Coverage for peace of mind. </strong></p>
        <p>
          <br /><br />
          <small style="color: #999">
            <router-link :to="{ name: 'legalAssurant' }">
              Assurant underwriter
            </router-link>
          </small>
        </p>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import HomeBurgerMenu from "@/views/partials/HomeBurgerMenu.vue";
import RentersLogo from "@/views/partials/RentersLogo.vue";
import { defineAsyncComponent } from "vue";

const emit = defineEmits(["showModal"]);
function showModal(args: any[]) {
  emit("showModal", args);
}
</script>
